import api from '@/utils/api';

/**
 * Create customer
 * @param {object} customerData - The user data
 * @returns {Promise}
 */
const createCustomerApi = (customerData) => api.post('/customer', customerData);

export default createCustomerApi;
